import { AnimationPropsBase } from '@unistocks/components/animations/animation-props';
import { AnimatedView, AnimatedViewProps } from '@unistocks/components/basic/animated-view';
import { PropsWithChildren, useEffect } from 'react';
import {
  cancelAnimation,
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming
} from 'react-native-reanimated';

export type RotateAnimationProps = PropsWithChildren<AnimationPropsBase & AnimatedViewProps>;

export const Rotate: React.FC<RotateAnimationProps> = ({
  enabled = true,
  duration = 1000,
  style,
  children,
  ...props
}) => {
  const rotation = useSharedValue(0);
  const rotateAnimation = useAnimatedStyle(() => {
    return {
      transform: [
        {
          rotate: `${rotation.value}deg`
        }
      ]
    };
  });

  useEffect(() => {
    if (enabled) {
      rotation.value = withRepeat(
        withTiming(360, {
          duration,
          easing: Easing.linear
        }),
        -1,
        false
      );
    } else {
      rotation.value = 0;
    }

    return () => cancelAnimation(rotation);
  }, [duration, enabled, rotation]);

  return (
    <AnimatedView style={[style, rotateAnimation]} {...props}>
      {children}
    </AnimatedView>
  );
};

Rotate.displayName = 'RotateAnimation';
